/* eslint-disable max-lines */
// Error keys from the mobile.de Seller API documentation, section Error Keys.
// too-many-photos is our own limit check and uses the same translation path.
const mobileDeErrors: Record<string, Record<string, string>> = {
  en: {
    'envkv-values-required':
      'The marker "envkv" requires all consumption and emission values and the fuel type being set. EnVKV values are required for new cars, single day registration and demonstration vehicles.',
    'constructionyear-registrationyear-pluasibility':
      'The year of construction cannot lie behind the first registration date. Please correct either the first registration date or the construction year',
    'closingcosts-invalid': 'Closing Costs Invalid',
    'make-model-mismatch': 'The selected model dooesn’t match the select make',
    'envkv-carbon-dioxyd-emission-invalid':
      'Please enter a positive carbon dioxyd emission value or leave the field empty',
    'usedcarseal-criteria-not-matched':
      'The vehicle does not match the necessary criteria for the Used Car Seal you selected',
    'envkv-consumption-combined-invalid':
      'Please enter a positive fuel consumption combined value or leave the field empty',
    'endingrate-invalid': 'Ending Rate Invalid',
    'make-empty': 'Please select a Make.',
    'rateinsurance-invalid': 'Rate Insurance Invalid',
    'netprice-without-vat': 'You must enter a valid VAT rate when using a net price',
    'liftingheight-invalid': 'The lifting height you entered is invalid',
    'mileage-empty': 'You must enter a mileage',
    'vehicleIdentificationNumber-invalid': 'The vehicle identification number (VIN) you entered is invalid',
    'loadingspaceheight-invalid': 'The loading space height is invalid',
    'usedcarseal-on-new-car-warning': 'The Used Car Seal can not be assigned to new cars',
    'firstinstallment-invalid': 'First Installment Invalid',
    'highlights-2-invalid-chars': 'The 2nd highlight contains invalid chars',
    'dealerpriceamount-invalid': 'The amount of the dealer price is invalid',
    'price-type-price type invalid': 'You must select a price type',
    'description-contains-phone': 'The description text is not allowed to contain a phone number',
    'envkv-consumption-outer-invalid':
      'Please enter a positive fuel consumption (extra-urban) value or leave the field empty',
    'highlights-1-too-long': 'The 1st highlight is too long (max. 22 chars)',
    'power-invalid-range': 'Power must be in a range from 0 to 999.',
    'envkv-consumption-outer-is-empty': 'Please enter the fuel consumption (extra-urban)',
    'operatinghours-invalid': 'The operating hours you entered are invalid',
    'nominalinterestrate-invalid': 'Nominal Interest Rate Invalid',
    'envkv-combined-power-consumption-invalid': 'combined power consumption invalid',
    'category-invalid': 'The Category you entered is invalid',
    'price-type-empty': 'You must select a price type',
    'invalid-video-url': 'Invalid YouTube Link',
    'ratepercent-invalid': 'Rate Per Cent Invalid',
    'price-empty': 'A price must be provided.',
    'period-invalid': 'Duration Invalid',
    'cubiccapacity-invalid': 'The cubic capacity you entered is invalid',
    'manufacturercolorname-too-long':
      'The manufacturer colour name you entered is too long. The maximum number of characters is 32.',
    'deliveryperiod-only-for-new-cars': 'You can only enter a delivery period for new vehicles',
    'model-empty': 'For the vehicle-class Car a model is required. See Reference Data.',
    'fuel-empty': 'You must select a fuel type.',
    'modeldescription-contains-phone': 'The model description may not contain a phone number.',
    'loadingspacelength-invalid': 'The load capacity you entered is invalid',
    'model-without-make': 'Please select both Make and Model',
    'envkv-and-electricity-failure': 'Less Envkv Fields When Fuel Type Electro',
    'manufacturercolorname-invalid-chars': 'The manufacturer colour name contains invalid characters',
    'deliverycost-invalid': 'Delivery costs invalid',
    'constructionyear-invalid': 'The construction year you entered is invalid',
    'usedcarseal-not-permitted': 'You are not authorized to use the Used Car Seal you selected',
    'countryversion-missing': 'Countryversion necessary for new cars.',
    'numberofbunks-invalid': 'The number of bunks is invalid',
    'highlights-3-too-long': 'The 3rd highlight is too long (max. 22 chars)',
    'highlights-2-too-long': 'The 2nd highlight is too long (max. 22 chars)',
    'select-country-version': 'The country version is missing',
    'highlights-3-invalid-chars': 'The 3rd highlight contains invalid chars',
    'vehiclelength-invalid': 'The vehicle length is invalid',
    'highlights-1-invalid-chars': 'The 1st highlight contains invalid chars',
    'first-registration': 'A first registration date is required for all used vehicles.',
    'numberOfPreviousOwners-invalid': 'Number Of Previous Owners Invalid',
    'deliverydate-year-too-low': 'The delivery year is too low',
    'dealer-price-not-supported': 'For FSBO Ads there cannot be a dealer price.',
    'installationheight-invalid': 'The installation height you entered is invalid',
    'loadcapacity-invalid': 'The load capacity you entered is invalid',
    'usagetype-demonstration-not-for-fsbo': 'No Demonstration Vehicles',
    'envkv-combined-power-consumption-is-empty': 'combined power consumption is empty',
    'modeldescription-too-long':
      'The model/variant you entered is too long (the model description may not be longer than 48 characters).',
    'modeldescription-contains-url': 'The model description may not contain a URL.',
    'vat-rate-not-allowed-for-on-request': 'VAT rate not allowed for on request',
    'usagetype-unsupported-for-new-vehicles':
      'A new vehicle cannot be a vehicle with pre-registration, employees-one-year-car, classic car or demonstration-vehicle.',
    'au-year-too-high':
      'Invalid year for AU (ASU - exhaust-inspection). The value must not be more than 6 years in future.',
    'firstregistration-classiccar-conflict': 'For classic cars the first registration must date back at least 20 years',
    'shippingvolume-invalid': 'The shipping volume is invalid',
    'currency-invalid-for-site': 'Currency invalid for site',
    'grosscreditamount-invalid': 'Gross Credit Amount Invalid',
    'vehiclewidth-invalid': 'The vehicle width is invalid',
    'europalletstoragespaces-invalid': 'The number of europallet storage spaces is invalid',
    'constructiondate-invalid': 'Date Of Manufacture Invalid',
    'firstregistration-invalid': 'The First Registration Date you entered is invalid',
    'manufacturercolorname-contains-url': 'The manufacturer colour name contains an URL',
    'condition-classiccar-conflict': 'The condition of a classic car must be set to used',
    'modeldescription-empty': 'Please enter the model or respectively the variant for cars',
    'category-empty': 'Please select a category.',
    'usedcarseal-on-damaged-car-warning': 'The Used Car Seal can not be assigned to damaged cars',
    'loadingspacewidth-invalid': 'The load capacity you entered is invalid',
    'envkv-carbon-dioxyd-emission-is-empty': 'Please enter the carbon dioxyd emission value',
    'firstregistration-employeescar-conflict': 'First registration must not be more than 23 months in the past.',
    'envkv-consumption-inner-invalid':
      'Please enter a positive fuel consumption (urban) value or leave the field empty',
    'delivery-period-xor-delivery-date':
      'For new Cars either delivery date or delivery period must be provided, but not both at the same time.',
    'envkv energy efficiency class is empty': 'Enter Efficiency Class',
    'average-price-not-for-damaged-vehicles': 'Average price cannot be calculated for cars with unrepaired damage',
    'mileage-used-invalid': 'The mileage you entered is invalid for a used car',
    'modeldescription-invalid-chars': 'The model/variant you entered contains invalid characters',
    'deliveryperiod-invalid': 'Delivery period invalid',
    'vat-rate-invalid': 'The VAT rate is invalid',
    'price-type-bidding-inconsistent': 'You must select a price type',
    'numberOfPreviousOwners-unsupported':
      'You are not able to specify previous owners for this vehicle because it is a new vehicle',
    'damageunrepaired-empty': 'You must select whether the vehicle has a unrepaired damage',
    'internalnumber-invalid-chars': 'The entered internal number contains invalid characters',
    'constructionyear-empty': 'Please enter the construction year',
    'bank-too-long': 'The Bank you entered is too long. The maximum number of characters is 150.',
    'firstregistration-newcar-conflict': 'The first registration date must be empty for new vehicles',
    'features-contains-invalid-value': 'Features contain invalid value',
    'internalnumber-too-long': 'The internal number you entered is too long (max. 40 characters)',
    'description-too-long': 'The description you entered is too long',
    'firstregistration-empty': 'Please fill in the First Registration Date',
    'consumerpriceamount-invalid':
      'The price amount is invalid. Please use only digits (no full stops or commas) when entering the price',
    'liftingcapacity-invalid': 'The lifting capacity you entered is invalid',
    'modeldescription-contains-email': 'The model description may not contain an e-mail address.',
    'envkv-consumption-inner-is-empty': 'Please enter the fuel consumption (urban)',
    'axles-invalid': 'The number of axles is invalid',
    'numseats-invalid': 'The number of seats you entered is invalid',
    'dealer-price-to-high': 'The dealer’s price cannot be higher than the retail price.',
    'currency-empty': 'Currency is empty',
    'monthlyrate-invalid': 'Rate Invalid',
    'deliverydate-year-too-high': 'The delivery year is too high',
    'vehicleheight-invalid': 'The vehicle height is invalid',
    'envkv-consumption-combined-is-empty': 'Please enter the fuel consumption combined',
    'netcreditamount-invalid': 'Net Credit Amount Invalid',
    'description-contains-email': 'The description text is not allowed to contain an email address',
    'description-empty': 'Please enter a description',
    'duplicate-seller-inventory-key': 'The internalNumber (AKA seller inventory key) must be unique for given seller',
    'ad-only-modifiable-in-dealer-area':
      'The dealer blocked changes to this ad (uploadSticky=true) and it can’t be changed via seller-api any more. The uploadSticky flag can be reset in the dealer area.',
    'licensedweight-invalid': 'The licensed weight you entered is invalid',
    'au-year-too-low': 'Invalid year for AU (ASU - exhaust-inspection). The value must not be before the year 1000.',
    'mileage-new-invalid': 'The mileage is invalid for a new car',
    'hu-year-too-low':
      'Invalid year for HU (TUEV / general-inspection / technical inspection / hu-date). The value must not be before the year 1000.',
    'internalnumber-contains-email': 'The entered internal number contains an email address',
    'hu-year-too-high':
      'Invalid year for HU (TUEV / general-inspection / technical inspection / hu-date). The value must not be more than 6 years in future.',
    'renewal-for-site-id-other-than-germany-not-allowed': 'Renewal is only allowed for Germany Site Id',
    'manufacturercolorname-contains-email': 'The manufacturer colour name contains an email address',
    'average-price-only-for-cars': 'Average price can only be calculated for cars',
    'power-empty': 'You must enter a power',
    'consumer-price-not-in-range': 'The price amount is not in a valid range',
    'make-invalid-category': 'The selected category is invalid for the selected make',
    'batterycapacity-invalid': 'The entered battery capacity is not in the range between 1 and 999 kWh',
    'modelrange-too-long': 'The model range contains too many characters. The maximum number of characters is 255.',
    'parkassists-cam-360-degrees-and-rear-view-cam-selected':
      'Rear view camera and 360° camera can’t be selected together',
    'trimline-too-long': 'The trim line contains too many characters. The maximum number of characters is 255.',
    'ad-deleted-by-mobile-quality':
      'The ad has been removed by the mobile.de quality team. Please see the adQuality for more details.',
    'request-id-too-long':
      'The value submitted in the `X-Mobile-Insertion-Request-Id` is too long. Max length is 100 characters.',
    'request-id-invalid-characters':
      'The value submitted int he `X-Mobile-Insertion-Request-Id` contains invalid characters. Only alphanumeric characters are allowed.',
    buyer_email_not_allowed: 'There are certain rules to prevent cheating.',
    invite_for_ad_already_exists: 'An invite for the mobileAdId already exists.',
    rating_for_ad_already_exists: 'A rating for the mobileAdId already exists.',
    ad_not_eligible: 'Only eligible mobileAdIds can be used to sent invitations.',
    personalized_invite_text_not_supported: 'Dealer needs to be at least in package Gold for this feature.',
    not_reinviteable: 'This mobileAdId is not reinviteable.',
    invite_email_invalid: 'Email address needs to be valid.',
    invite_email_empty: 'Email addrerss can not be empty.',
    invite_text_empty:
      'When no personalized invite text is required, it should not be send or set to null, but can not be blank.',
    invite_text_too_long: 'The personalized invite text can be maximum 3000 characters long.',
    rating_not_supported_for_dealer:
      'The Dealer needs to have at least account type Gold for rating management via API.',
    rating_reply_too_long: 'A rating reply can be maximum 1000 characters.',
    rating_reply_is_empty: 'A rating reply can not be empty.',
    'charging-time-invalid': 'Charging time must be in a range from 1 to 1439',
    'charging-time-fast-invalid': 'Fast charging time must be in a range from 1 to 1439',
    'content-too-large': 'File size exceeds max allowed size of 10MB',
    'leasing-only-price-type-cannot-be-changed':
      'The price type of a leasing-only ad cannot be changed, i.e., from LEASING_ONLY to FIXED',
    'leasing-only-ad-cannot-be-activated-without-leasing-rates':
      'To activate a leasing-only ad, one must set the leasing rates for the ad',
    'frame-height-invalid':
      'The frame height is not in valid range. The value must be between (and including) 30 and 80.',
    'frame-number-too-long': 'The frame number is too long. The maximum number of characters is 25.',
    'battery-capacity-wh-invalid':
      'The battery capacity is not in valid range. The value must be between (and including) 250 and 1500.',
    'weight-e-bike-invalid':
      'The weight of an E-Bike is not in valid range. The value must be between (and including) 8 and 90.',
    'number-of-gears-invalid':
      'The number of gears is not in valid range. The value must be between (and including) 1 and 24.',
    'condition-of-e-bike-must-be-new': 'The condition for E-Bike must be new',
    'e-bike-cannot-be-changed-to-other-vehicle-class':
      'E-Bike cannot be changed to other vehicle classes, i.e., from EBike to Car',
    'classic-leasing-not-allowed-for-e-bike': 'E-Bike cannot have classic leasing',
    'trailer-load-braked-invalid': 'The value must be in range from 0 to 99999.',
    'trailer-load-unbraked-invalid': 'The value must be in range from 0 to 99999.',
    'operating-weight-invalid': 'The value must be in range from 0 to 999999.',
    'fuel-tank-volume-invalid': 'The value must be in range from 0 to 9999.',
    'weight-invalid': 'The value must be in range from 0 to 999999.',
    'payload-invalid': 'The value must be in range from 0 to 9999.',
    'seatbelt-seats-invalid': 'The value must be in range from 0 to 9.',
    'individual-contact-duplicate-responsibility':
      'There already exists another individual contact with the same responsibility.',
    'individual-contact-max-count-reached':
      'The maximum number of individual contacts is reached for this account type.',
    Price_Rating_Repaired_Damage:
      'Price rating cannot be calculated for vehicles that have repaired damage. The vehicle must have no history of damage.',
    Price_Rating_Vehicle_Is_Damaged:
      'Price rating cannot be calculated for vehicles with unrepaired damage. The vehicle must be in undamaged condition.',
    Price_Rating_Not_Roadworthy:
      'Price rating is not available for vehicles that are not roadworthy. The vehicle must be in a roadworthy condition.',
    Price_Rating_No_New_Cars:
      'Price rating is not available for new vehicles. Only used vehicles are eligible for price rating.',
    Price_Rating_No_Old_Cars:
      'Price rating is not available for vehicles that exceed the maximum age limit. The vehicle is too old for a reliable price rating.',
    Price_Rating_Differing_Price_Too_Low:
      'The submitted price is significantly lower than the calculated market value range. Consider adjusting the price to match market conditions.',
    Price_Rating_Differing_Price_Too_High:
      'The submitted price is significantly higher than the calculated market value range. Consider adjusting the price to match market conditions.',
    Price_Rating_Only_Cars:
      'Price rating is only available for vehicles in the "Car" vehicle class. Other vehicle types are not supported for price rating.',
    Price_Rating_Not_Possible_Little_Data:
      'There is insufficient market data available to calculate a reliable price rating for this specific vehicle configuration.',
    'too-many-photos': 'Too many photos were selected for this account.'
  },
  pl: {
    'envkv-values-required':
      'Znacznik EnVKV wymaga podania zużycia, emisji i rodzaju paliwa. Wartości EnVKV są wymagane dla nowych aut, rejestracji jednodniowej i pojazdów demonstracyjnych.',
    'constructionyear-registrationyear-pluasibility':
      'Rok produkcji nie może być późniejszy niż data pierwszej rejestracji. Popraw datę pierwszej rejestracji albo rok produkcji.',
    'closingcosts-invalid': 'Koszty zamknięcia są nieprawidłowe.',
    'make-model-mismatch': 'Wybrany model nie pasuje do wybranej marki.',
    'envkv-carbon-dioxyd-emission-invalid': 'Podaj dodatnią emisję CO2 albo zostaw pole puste.',
    'usedcarseal-criteria-not-matched': 'Pojazd nie spełnia kryteriów wybranej plakietki samochodu używanego.',
    'envkv-consumption-combined-invalid': 'Podaj dodatnie łączne zużycie paliwa albo zostaw pole puste.',
    'endingrate-invalid': 'Rata końcowa jest nieprawidłowa.',
    'make-empty': 'Wybierz markę.',
    'rateinsurance-invalid': 'Ubezpieczenie raty jest nieprawidłowe.',
    'netprice-without-vat': 'Przy cenie netto trzeba podać prawidłową stawkę VAT.',
    'liftingheight-invalid': 'Podana wysokość podnoszenia jest nieprawidłowa.',
    'mileage-empty': 'Podaj przebieg.',
    'vehicleIdentificationNumber-invalid': 'Podany numer VIN jest nieprawidłowy.',
    'loadingspaceheight-invalid': 'Wysokość przestrzeni ładunkowej jest nieprawidłowa.',
    'usedcarseal-on-new-car-warning': 'Plakietki samochodu używanego nie można przypisać do nowego pojazdu.',
    'firstinstallment-invalid': 'Pierwsza rata jest nieprawidłowa.',
    'highlights-2-invalid-chars': 'Druga zaleta zawiera niedozwolone znaki.',
    'dealerpriceamount-invalid': 'Kwota ceny dealerskiej jest nieprawidłowa.',
    'price-type-price type invalid': 'Wybierz rodzaj ceny.',
    'description-contains-phone': 'Opis nie może zawierać numeru telefonu.',
    'envkv-consumption-outer-invalid': 'Podaj dodatnie zużycie paliwa poza miastem albo zostaw pole puste.',
    'highlights-1-too-long': 'Pierwsza zaleta jest za długa (maks. 22 znaki).',
    'power-invalid-range': 'Moc musi być w zakresie od 0 do 999.',
    'envkv-consumption-outer-is-empty': 'Podaj zużycie paliwa poza miastem.',
    'operatinghours-invalid': 'Podane motogodziny są nieprawidłowe.',
    'nominalinterestrate-invalid': 'Nominalna stopa procentowa jest nieprawidłowa.',
    'envkv-combined-power-consumption-invalid': 'Łączne zużycie energii jest nieprawidłowe.',
    'category-invalid': 'Wybrana kategoria jest nieprawidłowa.',
    'price-type-empty': 'Wybierz rodzaj ceny.',
    'invalid-video-url': 'Nieprawidłowy link do YouTube.',
    'ratepercent-invalid': 'Oprocentowanie raty jest nieprawidłowe.',
    'price-empty': 'Podaj cenę.',
    'period-invalid': 'Okres jest nieprawidłowy.',
    'cubiccapacity-invalid': 'Podana pojemność skokowa jest nieprawidłowa.',
    'manufacturercolorname-too-long': 'Nazwa koloru producenta jest za długa. Maksimum to 32 znaki.',
    'deliveryperiod-only-for-new-cars': 'Termin dostawy można podać tylko dla nowych pojazdów.',
    'model-empty': 'Dla klasy Car model jest wymagany.',
    'fuel-empty': 'Wybierz rodzaj paliwa.',
    'modeldescription-contains-phone': 'Opis modelu nie może zawierać numeru telefonu.',
    'loadingspacelength-invalid': 'Długość przestrzeni ładunkowej jest nieprawidłowa.',
    'model-without-make': 'Wybierz zarówno markę, jak i model.',
    'envkv-and-electricity-failure': 'Przy paliwie elektrycznym trzeba podać mniej pól EnVKV.',
    'manufacturercolorname-invalid-chars': 'Nazwa koloru producenta zawiera niedozwolone znaki.',
    'deliverycost-invalid': 'Koszt dostawy jest nieprawidłowy.',
    'constructionyear-invalid': 'Podany rok produkcji jest nieprawidłowy.',
    'usedcarseal-not-permitted': 'Nie masz uprawnień do wybranej plakietki samochodu używanego.',
    'countryversion-missing': 'Wersja krajowa jest wymagana dla nowych pojazdów.',
    'numberofbunks-invalid': 'Liczba koi jest nieprawidłowa.',
    'highlights-3-too-long': 'Trzecia zaleta jest za długa (maks. 22 znaki).',
    'highlights-2-too-long': 'Druga zaleta jest za długa (maks. 22 znaki).',
    'select-country-version': 'Brakuje wersji krajowej.',
    'highlights-3-invalid-chars': 'Trzecia zaleta zawiera niedozwolone znaki.',
    'vehiclelength-invalid': 'Długość pojazdu jest nieprawidłowa.',
    'highlights-1-invalid-chars': 'Pierwsza zaleta zawiera niedozwolone znaki.',
    'first-registration': 'Data pierwszej rejestracji jest wymagana dla używanych pojazdów.',
    'numberOfPreviousOwners-invalid': 'Liczba poprzednich właścicieli jest nieprawidłowa.',
    'deliverydate-year-too-low': 'Rok dostawy jest za niski.',
    'dealer-price-not-supported': 'W ogłoszeniach prywatnych nie można podać ceny dealerskiej.',
    'installationheight-invalid': 'Podana wysokość montażu jest nieprawidłowa.',
    'loadcapacity-invalid': 'Podana ładowność jest nieprawidłowa.',
    'usagetype-demonstration-not-for-fsbo': 'Pojazd demonstracyjny nie jest dozwolony.',
    'envkv-combined-power-consumption-is-empty': 'Brakuje łącznego zużycia energii.',
    'modeldescription-too-long': 'Opis modelu jest za długi (maks. 48 znaków).',
    'modeldescription-contains-url': 'Opis modelu nie może zawierać adresu URL.',
    'vat-rate-not-allowed-for-on-request': 'Stawka VAT nie jest dozwolona przy cenie na zapytanie.',
    'usagetype-unsupported-for-new-vehicles':
      'Nowy pojazd nie może być pojazdem z wcześniejszą rejestracją, rocznym autem pracowniczym, youngtimerem ani pojazdem demonstracyjnym.',
    'au-year-too-high': 'Rok badania spalin jest nieprawidłowy. Nie może być więcej niż 6 lat w przyszłość.',
    'firstregistration-classiccar-conflict': 'Dla klasyka pierwsza rejestracja musi być sprzed co najmniej 20 lat.',
    'shippingvolume-invalid': 'Objętość transportowa jest nieprawidłowa.',
    'currency-invalid-for-site': 'Waluta jest niedozwolona dla tego serwisu.',
    'grosscreditamount-invalid': 'Kwota kredytu brutto jest nieprawidłowa.',
    'vehiclewidth-invalid': 'Szerokość pojazdu jest nieprawidłowa.',
    'europalletstoragespaces-invalid': 'Liczba miejsc na europalety jest nieprawidłowa.',
    'constructiondate-invalid': 'Data produkcji jest nieprawidłowa.',
    'firstregistration-invalid': 'Podana data pierwszej rejestracji jest nieprawidłowa.',
    'manufacturercolorname-contains-url': 'Nazwa koloru producenta zawiera adres URL.',
    'condition-classiccar-conflict': 'Klasyk musi mieć stan „używany”.',
    'modeldescription-empty': 'Podaj model albo wariant.',
    'category-empty': 'Wybierz kategorię.',
    'usedcarseal-on-damaged-car-warning': 'Plakietki samochodu używanego nie można przypisać do uszkodzonego pojazdu.',
    'loadingspacewidth-invalid': 'Szerokość przestrzeni ładunkowej jest nieprawidłowa.',
    'envkv-carbon-dioxyd-emission-is-empty': 'Podaj emisję CO2.',
    'firstregistration-employeescar-conflict': 'Pierwsza rejestracja nie może być starsza niż 23 miesiące.',
    'envkv-consumption-inner-invalid': 'Podaj dodatnie zużycie paliwa w mieście albo zostaw pole puste.',
    'delivery-period-xor-delivery-date':
      'Dla nowego auta podaj albo datę dostawy, albo okres dostawy, ale nie oba naraz.',
    'envkv energy efficiency class is empty': 'Podaj klasę efektywności energetycznej.',
    'average-price-not-for-damaged-vehicles': 'Średniej ceny nie można wyliczyć dla pojazdów z nienaprawioną szkodą.',
    'mileage-used-invalid': 'Podany przebieg jest nieprawidłowy dla używanego pojazdu.',
    'modeldescription-invalid-chars': 'Opis modelu zawiera niedozwolone znaki.',
    'deliveryperiod-invalid': 'Okres dostawy jest nieprawidłowy.',
    'vat-rate-invalid': 'Stawka VAT jest nieprawidłowa.',
    'price-type-bidding-inconsistent': 'Wybierz rodzaj ceny.',
    'numberOfPreviousOwners-unsupported': 'Dla nowego pojazdu nie można podać liczby poprzednich właścicieli.',
    'damageunrepaired-empty': 'Wybierz, czy pojazd ma nienaprawioną szkodę.',
    'internalnumber-invalid-chars': 'Numer wewnętrzny zawiera niedozwolone znaki.',
    'constructionyear-empty': 'Podaj rok produkcji.',
    'bank-too-long': 'Nazwa banku jest za długa. Maksimum to 150 znaków.',
    'firstregistration-newcar-conflict': 'Data pierwszej rejestracji musi być pusta dla nowych pojazdów.',
    'features-contains-invalid-value': 'Wyposażenie zawiera niedozwoloną wartość.',
    'internalnumber-too-long': 'Numer wewnętrzny jest za długi (maks. 40 znaków).',
    'description-too-long': 'Opis jest za długi.',
    'firstregistration-empty': 'Podaj datę pierwszej rejestracji.',
    'consumerpriceamount-invalid': 'Kwota ceny jest nieprawidłowa. Użyj samych cyfr, bez kropek i przecinków.',
    'liftingcapacity-invalid': 'Podany udźwig jest nieprawidłowy.',
    'modeldescription-contains-email': 'Opis modelu nie może zawierać adresu e-mail.',
    'envkv-consumption-inner-is-empty': 'Podaj zużycie paliwa w mieście.',
    'axles-invalid': 'Liczba osi jest nieprawidłowa.',
    'numseats-invalid': 'Podana liczba miejsc jest nieprawidłowa.',
    'dealer-price-to-high': 'Cena dealerska nie może być wyższa od ceny detalicznej.',
    'currency-empty': 'Brakuje waluty.',
    'monthlyrate-invalid': 'Rata jest nieprawidłowa.',
    'deliverydate-year-too-high': 'Rok dostawy jest za wysoki.',
    'vehicleheight-invalid': 'Wysokość pojazdu jest nieprawidłowa.',
    'envkv-consumption-combined-is-empty': 'Podaj łączne zużycie paliwa.',
    'netcreditamount-invalid': 'Kwota kredytu netto jest nieprawidłowa.',
    'description-contains-email': 'Opis nie może zawierać adresu e-mail.',
    'description-empty': 'Podaj opis.',
    'duplicate-seller-inventory-key': 'Numer wewnętrzny musi być unikalny u tego sprzedawcy.',
    'ad-only-modifiable-in-dealer-area':
      'Dealer zablokował zmiany tego ogłoszenia. Można je zmienić tylko w panelu dealera.',
    'licensedweight-invalid': 'Podana dopuszczalna masa całkowita jest nieprawidłowa.',
    'au-year-too-low': 'Rok badania spalin jest nieprawidłowy. Nie może być wcześniejszy niż rok 1000.',
    'mileage-new-invalid': 'Przebieg jest nieprawidłowy dla nowego pojazdu.',
    'hu-year-too-low': 'Rok badania technicznego jest nieprawidłowy. Nie może być wcześniejszy niż rok 1000.',
    'internalnumber-contains-email': 'Numer wewnętrzny zawiera adres e-mail.',
    'hu-year-too-high': 'Rok badania technicznego jest nieprawidłowy. Nie może być więcej niż 6 lat w przyszłość.',
    'renewal-for-site-id-other-than-germany-not-allowed': 'Odnowienie jest dozwolone tylko dla serwisu Niemcy.',
    'manufacturercolorname-contains-email': 'Nazwa koloru producenta zawiera adres e-mail.',
    'average-price-only-for-cars': 'Średnią cenę można wyliczyć tylko dla samochodów.',
    'power-empty': 'Podaj moc.',
    'consumer-price-not-in-range': 'Kwota ceny jest poza dozwolonym zakresem.',
    'make-invalid-category': 'Wybrana kategoria jest niedozwolona dla wybranej marki.',
    'batterycapacity-invalid': 'Pojemność baterii musi być w zakresie od 1 do 999 kWh.',
    'modelrange-too-long': 'Nazwa gamy modelowej jest za długa. Maksimum to 255 znaków.',
    'parkassists-cam-360-degrees-and-rear-view-cam-selected':
      'Kamery cofania i kamery 360° nie można wybrać jednocześnie.',
    'trimline-too-long': 'Nazwa wersji wyposażenia jest za długa. Maksimum to 255 znaków.',
    'ad-deleted-by-mobile-quality': 'Ogłoszenie zostało usunięte przez zespół jakości mobile.de.',
    'request-id-too-long': 'Identyfikator żądania jest za długi. Maksimum to 100 znaków.',
    'request-id-invalid-characters':
      'Identyfikator żądania zawiera niedozwolone znaki. Dozwolone są tylko znaki alfanumeryczne.',
    buyer_email_not_allowed: 'Adres e-mail kupującego jest niedozwolony.',
    invite_for_ad_already_exists: 'Zaproszenie do tego ogłoszenia już istnieje.',
    rating_for_ad_already_exists: 'Ocena tego ogłoszenia już istnieje.',
    ad_not_eligible: 'Tego ogłoszenia nie można użyć do wysłania zaproszenia.',
    personalized_invite_text_not_supported: 'Spersonalizowany tekst zaproszenia wymaga co najmniej pakietu Gold.',
    not_reinviteable: 'Do tego ogłoszenia nie można wysłać ponownego zaproszenia.',
    invite_email_invalid: 'Adres e-mail zaproszenia musi być prawidłowy.',
    invite_email_empty: 'Adres e-mail zaproszenia nie może być pusty.',
    invite_text_empty: 'Tekst zaproszenia nie może być pusty.',
    invite_text_too_long: 'Spersonalizowany tekst zaproszenia może mieć maksymalnie 3000 znaków.',
    rating_not_supported_for_dealer: 'Zarządzanie ocenami przez API wymaga co najmniej konta Gold.',
    rating_reply_too_long: 'Odpowiedź na ocenę może mieć maksymalnie 1000 znaków.',
    rating_reply_is_empty: 'Odpowiedź na ocenę nie może być pusta.',
    'charging-time-invalid': 'Czas ładowania musi być w zakresie od 1 do 1439.',
    'charging-time-fast-invalid': 'Czas szybkiego ładowania musi być w zakresie od 1 do 1439.',
    'content-too-large': 'Plik przekracza dozwolone 10 MB.',
    'leasing-only-price-type-cannot-be-changed': 'Typu ceny ogłoszenia tylko leasingowego nie można zmienić.',
    'leasing-only-ad-cannot-be-activated-without-leasing-rates':
      'Aby aktywować ogłoszenie tylko leasingowe, trzeba podać raty leasingu.',
    'frame-height-invalid': 'Wysokość ramy musi być w zakresie od 30 do 80.',
    'frame-number-too-long': 'Numer ramy jest za długi. Maksimum to 25 znaków.',
    'battery-capacity-wh-invalid': 'Pojemność baterii musi być w zakresie od 250 do 1500.',
    'weight-e-bike-invalid': 'Masa e-bike musi być w zakresie od 8 do 90.',
    'number-of-gears-invalid': 'Liczba biegów musi być w zakresie od 1 do 24.',
    'condition-of-e-bike-must-be-new': 'E-bike musi mieć stan „nowy”.',
    'e-bike-cannot-be-changed-to-other-vehicle-class': 'E-bike nie może zmienić klasy pojazdu.',
    'classic-leasing-not-allowed-for-e-bike': 'E-bike nie może mieć klasycznego leasingu.',
    'trailer-load-braked-invalid': 'Masa przyczepy z hamulcem musi być w zakresie od 0 do 99999.',
    'trailer-load-unbraked-invalid': 'Masa przyczepy bez hamulca musi być w zakresie od 0 do 99999.',
    'operating-weight-invalid': 'Masa eksploatacyjna musi być w zakresie od 0 do 999999.',
    'fuel-tank-volume-invalid': 'Pojemność zbiornika musi być w zakresie od 0 do 9999.',
    'weight-invalid': 'Masa musi być w zakresie od 0 do 999999.',
    'payload-invalid': 'Ładowność musi być w zakresie od 0 do 9999.',
    'seatbelt-seats-invalid': 'Liczba miejsc z pasami musi być w zakresie od 0 do 9.',
    'individual-contact-duplicate-responsibility':
      'Istnieje już inny kontakt indywidualny z tym samym zakresem odpowiedzialności.',
    'individual-contact-max-count-reached':
      'Osiągnięto maksymalną liczbę kontaktów indywidualnych dla tego typu konta.',
    Price_Rating_Repaired_Damage: 'Wyceny nie można obliczyć dla pojazdów z naprawioną szkodą.',
    Price_Rating_Vehicle_Is_Damaged: 'Wyceny nie można obliczyć dla pojazdów z nienaprawioną szkodą.',
    Price_Rating_Not_Roadworthy: 'Wycena nie jest dostępna dla pojazdów niezdolnych do ruchu.',
    Price_Rating_No_New_Cars: 'Wycena nie jest dostępna dla nowych pojazdów.',
    Price_Rating_No_Old_Cars: 'Pojazd jest za stary, żeby wyliczyć wiarygodną wycenę.',
    Price_Rating_Differing_Price_Too_Low: 'Podana cena jest znacznie niższa od wyliczonego zakresu rynkowego.',
    Price_Rating_Differing_Price_Too_High: 'Podana cena jest znacznie wyższa od wyliczonego zakresu rynkowego.',
    Price_Rating_Only_Cars: 'Wycena jest dostępna tylko dla samochodów.',
    Price_Rating_Not_Possible_Little_Data: 'Brakuje danych rynkowych, żeby wyliczyć wiarygodną wycenę.',
    'too-many-photos': 'Wybrano za dużo zdjęć dla tego konta.'
  },
  de: {
    'envkv-values-required':
      'Die EnVKV-Angabe erfordert Verbrauch, Emission und Kraftstoffart. EnVKV-Werte sind für Neuwagen, Tageszulassungen und Vorführwagen erforderlich.',
    'constructionyear-registrationyear-pluasibility':
      'Das Baujahr darf nicht nach dem Erstzulassungsdatum liegen. Korrigieren Sie das Erstzulassungsdatum oder das Baujahr.',
    'closingcosts-invalid': 'Die Abschlusskosten sind ungültig.',
    'make-model-mismatch': 'Das gewählte Modell passt nicht zur gewählten Marke.',
    'envkv-carbon-dioxyd-emission-invalid': 'Geben Sie einen positiven CO2-Wert ein oder lassen Sie das Feld leer.',
    'usedcarseal-criteria-not-matched': 'Das Fahrzeug erfüllt die Kriterien des gewählten Gebrauchtwagensiegels nicht.',
    'envkv-consumption-combined-invalid':
      'Geben Sie einen positiven kombinierten Verbrauch ein oder lassen Sie das Feld leer.',
    'endingrate-invalid': 'Die Schlussrate ist ungültig.',
    'make-empty': 'Bitte wählen Sie eine Marke.',
    'rateinsurance-invalid': 'Die Ratenversicherung ist ungültig.',
    'netprice-without-vat': 'Bei einem Nettopreis muss ein gültiger Mehrwertsteuersatz angegeben werden.',
    'liftingheight-invalid': 'Die angegebene Hubhöhe ist ungültig.',
    'mileage-empty': 'Bitte geben Sie einen Kilometerstand ein.',
    'vehicleIdentificationNumber-invalid': 'Die angegebene Fahrzeug-Identifizierungsnummer (FIN) ist ungültig.',
    'loadingspaceheight-invalid': 'Die Laderaumhöhe ist ungültig.',
    'usedcarseal-on-new-car-warning': 'Ein Gebrauchtwagensiegel kann keinem Neufahrzeug zugeordnet werden.',
    'firstinstallment-invalid': 'Die Anzahlung ist ungültig.',
    'highlights-2-invalid-chars': 'Das zweite Highlight enthält ungültige Zeichen.',
    'dealerpriceamount-invalid': 'Der Händlerpreis ist ungültig.',
    'price-type-price type invalid': 'Bitte wählen Sie eine Preisart.',
    'description-contains-phone': 'Die Beschreibung darf keine Telefonnummer enthalten.',
    'envkv-consumption-outer-invalid':
      'Geben Sie einen positiven Außerortsverbrauch ein oder lassen Sie das Feld leer.',
    'highlights-1-too-long': 'Das erste Highlight ist zu lang (max. 22 Zeichen).',
    'power-invalid-range': 'Die Leistung muss zwischen 0 und 999 liegen.',
    'envkv-consumption-outer-is-empty': 'Bitte geben Sie den Außerortsverbrauch ein.',
    'operatinghours-invalid': 'Die angegebenen Betriebsstunden sind ungültig.',
    'nominalinterestrate-invalid': 'Der Nominalzins ist ungültig.',
    'envkv-combined-power-consumption-invalid': 'Der kombinierte Stromverbrauch ist ungültig.',
    'category-invalid': 'Die gewählte Kategorie ist ungültig.',
    'price-type-empty': 'Bitte wählen Sie eine Preisart.',
    'invalid-video-url': 'Ungültiger YouTube-Link.',
    'ratepercent-invalid': 'Der Ratenzins ist ungültig.',
    'price-empty': 'Ein Preis muss angegeben werden.',
    'period-invalid': 'Die Laufzeit ist ungültig.',
    'cubiccapacity-invalid': 'Der angegebene Hubraum ist ungültig.',
    'manufacturercolorname-too-long': 'Der Herstellerfarbname ist zu lang. Maximal 32 Zeichen.',
    'deliveryperiod-only-for-new-cars': 'Eine Lieferzeit kann nur für Neufahrzeuge angegeben werden.',
    'model-empty': 'Für die Fahrzeugklasse Car ist ein Modell erforderlich.',
    'fuel-empty': 'Bitte wählen Sie eine Kraftstoffart.',
    'modeldescription-contains-phone': 'Die Modellbeschreibung darf keine Telefonnummer enthalten.',
    'loadingspacelength-invalid': 'Die Laderaumlänge ist ungültig.',
    'model-without-make': 'Bitte wählen Sie Marke und Modell.',
    'envkv-and-electricity-failure': 'Bei Elektroantrieb sind weniger EnVKV-Felder anzugeben.',
    'manufacturercolorname-invalid-chars': 'Der Herstellerfarbname enthält ungültige Zeichen.',
    'deliverycost-invalid': 'Die Lieferkosten sind ungültig.',
    'constructionyear-invalid': 'Das angegebene Baujahr ist ungültig.',
    'usedcarseal-not-permitted': 'Sie dürfen das gewählte Gebrauchtwagensiegel nicht verwenden.',
    'countryversion-missing': 'Für Neufahrzeuge ist die Länderversion erforderlich.',
    'numberofbunks-invalid': 'Die Anzahl der Schlafplätze ist ungültig.',
    'highlights-3-too-long': 'Das dritte Highlight ist zu lang (max. 22 Zeichen).',
    'highlights-2-too-long': 'Das zweite Highlight ist zu lang (max. 22 Zeichen).',
    'select-country-version': 'Die Länderversion fehlt.',
    'highlights-3-invalid-chars': 'Das dritte Highlight enthält ungültige Zeichen.',
    'vehiclelength-invalid': 'Die Fahrzeuglänge ist ungültig.',
    'highlights-1-invalid-chars': 'Das erste Highlight enthält ungültige Zeichen.',
    'first-registration': 'Für gebrauchte Fahrzeuge ist ein Erstzulassungsdatum erforderlich.',
    'numberOfPreviousOwners-invalid': 'Die Anzahl der Vorbesitzer ist ungültig.',
    'deliverydate-year-too-low': 'Das Lieferjahr ist zu niedrig.',
    'dealer-price-not-supported': 'Bei privaten Inseraten ist kein Händlerpreis möglich.',
    'installationheight-invalid': 'Die angegebene Einbauhöhe ist ungültig.',
    'loadcapacity-invalid': 'Die angegebene Nutzlast ist ungültig.',
    'usagetype-demonstration-not-for-fsbo': 'Vorführwagen sind hier nicht zulässig.',
    'envkv-combined-power-consumption-is-empty': 'Der kombinierte Stromverbrauch fehlt.',
    'modeldescription-too-long': 'Die Modellbeschreibung ist zu lang (maximal 48 Zeichen).',
    'modeldescription-contains-url': 'Die Modellbeschreibung darf keine URL enthalten.',
    'vat-rate-not-allowed-for-on-request': 'Ein Mehrwertsteuersatz ist bei Preis auf Anfrage nicht zulässig.',
    'usagetype-unsupported-for-new-vehicles':
      'Ein Neufahrzeug kann keine Tageszulassung, kein Jahreswagen, kein Oldtimer und kein Vorführwagen sein.',
    'au-year-too-high': 'Das Jahr der Abgasuntersuchung ist ungültig. Es darf höchstens 6 Jahre in der Zukunft liegen.',
    'firstregistration-classiccar-conflict': 'Bei Oldtimern muss die Erstzulassung mindestens 20 Jahre zurückliegen.',
    'shippingvolume-invalid': 'Das Versandvolumen ist ungültig.',
    'currency-invalid-for-site': 'Die Währung ist für diesen Markt ungültig.',
    'grosscreditamount-invalid': 'Der Bruttokreditbetrag ist ungültig.',
    'vehiclewidth-invalid': 'Die Fahrzeugbreite ist ungültig.',
    'europalletstoragespaces-invalid': 'Die Anzahl der Europaletten-Stellplätze ist ungültig.',
    'constructiondate-invalid': 'Das Herstellungsdatum ist ungültig.',
    'firstregistration-invalid': 'Das angegebene Erstzulassungsdatum ist ungültig.',
    'manufacturercolorname-contains-url': 'Der Herstellerfarbname enthält eine URL.',
    'condition-classiccar-conflict': 'Ein Oldtimer muss den Zustand „gebraucht“ haben.',
    'modeldescription-empty': 'Bitte geben Sie Modell oder Variante ein.',
    'category-empty': 'Bitte wählen Sie eine Kategorie.',
    'usedcarseal-on-damaged-car-warning':
      'Ein Gebrauchtwagensiegel kann keinem beschädigten Fahrzeug zugeordnet werden.',
    'loadingspacewidth-invalid': 'Die Laderaumbreite ist ungültig.',
    'envkv-carbon-dioxyd-emission-is-empty': 'Bitte geben Sie den CO2-Ausstoß ein.',
    'firstregistration-employeescar-conflict': 'Die Erstzulassung darf nicht mehr als 23 Monate zurückliegen.',
    'envkv-consumption-inner-invalid':
      'Geben Sie einen positiven innerorts Verbrauch ein oder lassen Sie das Feld leer.',
    'delivery-period-xor-delivery-date':
      'Für Neuwagen entweder Lieferdatum oder Lieferzeit angeben, aber nicht beides.',
    'envkv energy efficiency class is empty': 'Bitte geben Sie die Energieeffizienzklasse ein.',
    'average-price-not-for-damaged-vehicles':
      'Der Durchschnittspreis kann für Fahrzeuge mit unrepariertem Schaden nicht berechnet werden.',
    'mileage-used-invalid': 'Der eingegebene Kilometerstand ist für ein gebrauchtes Fahrzeug ungültig.',
    'modeldescription-invalid-chars': 'Die Modellbeschreibung enthält ungültige Zeichen.',
    'deliveryperiod-invalid': 'Die Lieferzeit ist ungültig.',
    'vat-rate-invalid': 'Der Mehrwertsteuersatz ist ungültig.',
    'price-type-bidding-inconsistent': 'Bitte wählen Sie eine Preisart.',
    'numberOfPreviousOwners-unsupported': 'Für ein Neufahrzeug kann keine Anzahl der Vorbesitzer angegeben werden.',
    'damageunrepaired-empty': 'Bitte geben Sie an, ob das Fahrzeug einen unreparierten Schaden hat.',
    'internalnumber-invalid-chars': 'Die interne Nummer enthält ungültige Zeichen.',
    'constructionyear-empty': 'Bitte geben Sie das Baujahr ein.',
    'bank-too-long': 'Der Bankname ist zu lang. Maximal 150 Zeichen.',
    'firstregistration-newcar-conflict': 'Das Erstzulassungsdatum muss bei Neufahrzeugen leer sein.',
    'features-contains-invalid-value': 'Die Ausstattung enthält einen ungültigen Wert.',
    'internalnumber-too-long': 'Die interne Nummer ist zu lang (max. 40 Zeichen).',
    'description-too-long': 'Die Beschreibung ist zu lang.',
    'firstregistration-empty': 'Bitte geben Sie das Erstzulassungsdatum ein.',
    'consumerpriceamount-invalid': 'Der Preisbetrag ist ungültig. Verwenden Sie nur Ziffern, ohne Punkte oder Kommas.',
    'liftingcapacity-invalid': 'Die angegebene Tragfähigkeit ist ungültig.',
    'modeldescription-contains-email': 'Die Modellbeschreibung darf keine E-Mail-Adresse enthalten.',
    'envkv-consumption-inner-is-empty': 'Bitte geben Sie den innerorts Verbrauch ein.',
    'axles-invalid': 'Die Achszahl ist ungültig.',
    'numseats-invalid': 'Die angegebene Sitzplatzzahl ist ungültig.',
    'dealer-price-to-high': 'Der Händlerpreis darf nicht höher als der Endkundenpreis sein.',
    'currency-empty': 'Die Währung fehlt.',
    'monthlyrate-invalid': 'Die Rate ist ungültig.',
    'deliverydate-year-too-high': 'Das Lieferjahr ist zu hoch.',
    'vehicleheight-invalid': 'Die Fahrzeughöhe ist ungültig.',
    'envkv-consumption-combined-is-empty': 'Bitte geben Sie den kombinierten Verbrauch ein.',
    'netcreditamount-invalid': 'Der Nettokreditbetrag ist ungültig.',
    'description-contains-email': 'Die Beschreibung darf keine E-Mail-Adresse enthalten.',
    'description-empty': 'Bitte geben Sie eine Beschreibung ein.',
    'duplicate-seller-inventory-key': 'Die interne Nummer muss für diesen Verkäufer eindeutig sein.',
    'ad-only-modifiable-in-dealer-area':
      'Der Händler hat Änderungen an diesem Inserat gesperrt. Es kann nur im Händlerbereich geändert werden.',
    'licensedweight-invalid': 'Das angegebene zulässige Gesamtgewicht ist ungültig.',
    'au-year-too-low': 'Das Jahr der Abgasuntersuchung ist ungültig. Es darf nicht vor dem Jahr 1000 liegen.',
    'mileage-new-invalid': 'Der Kilometerstand ist für ein Neufahrzeug ungültig.',
    'hu-year-too-low': 'Das Jahr der Hauptuntersuchung ist ungültig. Es darf nicht vor dem Jahr 1000 liegen.',
    'internalnumber-contains-email': 'Die interne Nummer enthält eine E-Mail-Adresse.',
    'hu-year-too-high': 'Das Jahr der Hauptuntersuchung ist ungültig. Es darf höchstens 6 Jahre in der Zukunft liegen.',
    'renewal-for-site-id-other-than-germany-not-allowed':
      'Eine Verlängerung ist nur für den Markt Deutschland zulässig.',
    'manufacturercolorname-contains-email': 'Der Herstellerfarbname enthält eine E-Mail-Adresse.',
    'average-price-only-for-cars': 'Der Durchschnittspreis kann nur für Pkw berechnet werden.',
    'power-empty': 'Bitte geben Sie eine Leistung ein.',
    'consumer-price-not-in-range': 'Der Preisbetrag liegt außerhalb des zulässigen Bereichs.',
    'make-invalid-category': 'Die gewählte Kategorie ist für die gewählte Marke ungültig.',
    'batterycapacity-invalid': 'Die Batteriekapazität muss zwischen 1 und 999 kWh liegen.',
    'modelrange-too-long': 'Die Modellreihe ist zu lang. Maximal 255 Zeichen.',
    'parkassists-cam-360-degrees-and-rear-view-cam-selected':
      'Rückfahrkamera und 360°-Kamera können nicht gleichzeitig gewählt werden.',
    'trimline-too-long': 'Die Ausstattungslinie ist zu lang. Maximal 255 Zeichen.',
    'ad-deleted-by-mobile-quality': 'Das Inserat wurde vom Qualitätsteam von mobile.de entfernt.',
    'request-id-too-long': 'Die Anfragekennung ist zu lang. Maximal 100 Zeichen.',
    'request-id-invalid-characters':
      'Die Anfragekennung enthält ungültige Zeichen. Nur alphanumerische Zeichen sind erlaubt.',
    buyer_email_not_allowed: 'Die E-Mail-Adresse des Käufers ist nicht zulässig.',
    invite_for_ad_already_exists: 'Für dieses Inserat existiert bereits eine Einladung.',
    rating_for_ad_already_exists: 'Für dieses Inserat existiert bereits eine Bewertung.',
    ad_not_eligible: 'Dieses Inserat kann nicht für eine Einladung verwendet werden.',
    personalized_invite_text_not_supported: 'Ein persönlicher Einladungstext erfordert mindestens das Paket Gold.',
    not_reinviteable: 'Für dieses Inserat kann keine erneute Einladung gesendet werden.',
    invite_email_invalid: 'Die E-Mail-Adresse der Einladung muss gültig sein.',
    invite_email_empty: 'Die E-Mail-Adresse der Einladung darf nicht leer sein.',
    invite_text_empty: 'Der Einladungstext darf nicht leer sein.',
    invite_text_too_long: 'Der persönliche Einladungstext darf höchstens 3000 Zeichen lang sein.',
    rating_not_supported_for_dealer: 'Die Bewertungsverwaltung über die API erfordert mindestens ein Gold-Konto.',
    rating_reply_too_long: 'Eine Antwort auf eine Bewertung darf höchstens 1000 Zeichen lang sein.',
    rating_reply_is_empty: 'Eine Antwort auf eine Bewertung darf nicht leer sein.',
    'charging-time-invalid': 'Die Ladezeit muss zwischen 1 und 1439 liegen.',
    'charging-time-fast-invalid': 'Die Schnellladezeit muss zwischen 1 und 1439 liegen.',
    'content-too-large': 'Die Datei überschreitet die erlaubten 10 MB.',
    'leasing-only-price-type-cannot-be-changed':
      'Die Preisart eines reinen Leasinginserats kann nicht geändert werden.',
    'leasing-only-ad-cannot-be-activated-without-leasing-rates':
      'Um ein reines Leasinginserat zu aktivieren, müssen Leasingraten angegeben werden.',
    'frame-height-invalid': 'Die Rahmenhöhe muss zwischen 30 und 80 liegen.',
    'frame-number-too-long': 'Die Rahmennummer ist zu lang. Maximal 25 Zeichen.',
    'battery-capacity-wh-invalid': 'Die Batteriekapazität muss zwischen 250 und 1500 liegen.',
    'weight-e-bike-invalid': 'Das Gewicht eines E-Bikes muss zwischen 8 und 90 liegen.',
    'number-of-gears-invalid': 'Die Gangzahl muss zwischen 1 und 24 liegen.',
    'condition-of-e-bike-must-be-new': 'Ein E-Bike muss den Zustand „neu“ haben.',
    'e-bike-cannot-be-changed-to-other-vehicle-class':
      'Ein E-Bike kann nicht in eine andere Fahrzeugklasse geändert werden.',
    'classic-leasing-not-allowed-for-e-bike': 'Ein E-Bike kann kein klassisches Leasing haben.',
    'trailer-load-braked-invalid': 'Die gebremste Anhängelast muss zwischen 0 und 99999 liegen.',
    'trailer-load-unbraked-invalid': 'Die ungebremste Anhängelast muss zwischen 0 und 99999 liegen.',
    'operating-weight-invalid': 'Das Betriebsgewicht muss zwischen 0 und 999999 liegen.',
    'fuel-tank-volume-invalid': 'Das Tankvolumen muss zwischen 0 und 9999 liegen.',
    'weight-invalid': 'Das Gewicht muss zwischen 0 und 999999 liegen.',
    'payload-invalid': 'Die Nutzlast muss zwischen 0 und 9999 liegen.',
    'seatbelt-seats-invalid': 'Die Anzahl der Sitzplätze mit Gurt muss zwischen 0 und 9 liegen.',
    'individual-contact-duplicate-responsibility':
      'Es gibt bereits einen anderen Einzelkontakt mit derselben Zuständigkeit.',
    'individual-contact-max-count-reached': 'Die maximale Anzahl Einzelkontakte für diesen Kontotyp ist erreicht.',
    Price_Rating_Repaired_Damage: 'Eine Preisbewertung ist für Fahrzeuge mit repariertem Schaden nicht möglich.',
    Price_Rating_Vehicle_Is_Damaged: 'Eine Preisbewertung ist für Fahrzeuge mit unrepariertem Schaden nicht möglich.',
    Price_Rating_Not_Roadworthy: 'Eine Preisbewertung ist für nicht fahrbereite Fahrzeuge nicht verfügbar.',
    Price_Rating_No_New_Cars: 'Eine Preisbewertung ist für Neufahrzeuge nicht verfügbar.',
    Price_Rating_No_Old_Cars: 'Das Fahrzeug ist zu alt für eine verlässliche Preisbewertung.',
    Price_Rating_Differing_Price_Too_Low: 'Der angegebene Preis liegt deutlich unter dem berechneten Marktwert.',
    Price_Rating_Differing_Price_Too_High: 'Der angegebene Preis liegt deutlich über dem berechneten Marktwert.',
    Price_Rating_Only_Cars: 'Eine Preisbewertung ist nur für Pkw verfügbar.',
    Price_Rating_Not_Possible_Little_Data: 'Es liegen zu wenige Marktdaten für eine verlässliche Preisbewertung vor.',
    'too-many-photos': 'Für dieses Konto wurden zu viele Fotos ausgewählt.'
  },
  ro: {
    'envkv-values-required':
      'Marcajul EnVKV cere consumul, emisiile și tipul de combustibil. Valorile EnVKV sunt obligatorii pentru mașini noi, înmatriculare de o zi și vehicule demonstrative.',
    'constructionyear-registrationyear-pluasibility':
      'Anul fabricației nu poate fi după data primei înmatriculări. Corectați data primei înmatriculări sau anul fabricației.',
    'closingcosts-invalid': 'Costurile de închidere sunt invalide.',
    'make-model-mismatch': 'Modelul ales nu corespunde mărcii alese.',
    'envkv-carbon-dioxyd-emission-invalid': 'Introduceți o emisie de CO2 pozitivă sau lăsați câmpul gol.',
    'usedcarseal-criteria-not-matched': 'Vehiculul nu îndeplinește criteriile sigiliului de mașină rulată ales.',
    'envkv-consumption-combined-invalid': 'Introduceți un consum combinat pozitiv sau lăsați câmpul gol.',
    'endingrate-invalid': 'Rata finală este invalidă.',
    'make-empty': 'Alegeți marca.',
    'rateinsurance-invalid': 'Asigurarea ratei este invalidă.',
    'netprice-without-vat': 'La un preț net trebuie indicată o cotă de TVA validă.',
    'liftingheight-invalid': 'Înălțimea de ridicare indicată este invalidă.',
    'mileage-empty': 'Introduceți kilometrajul.',
    'vehicleIdentificationNumber-invalid': 'Numărul VIN indicat este invalid.',
    'loadingspaceheight-invalid': 'Înălțimea spațiului de încărcare este invalidă.',
    'usedcarseal-on-new-car-warning': 'Sigiliul de mașină rulată nu poate fi atribuit unui vehicul nou.',
    'firstinstallment-invalid': 'Prima rată este invalidă.',
    'highlights-2-invalid-chars': 'Al doilea avantaj conține caractere nepermise.',
    'dealerpriceamount-invalid': 'Suma prețului de dealer este invalidă.',
    'price-type-price type invalid': 'Alegeți tipul de preț.',
    'description-contains-phone': 'Descrierea nu poate conține un număr de telefon.',
    'envkv-consumption-outer-invalid': 'Introduceți un consum extraurban pozitiv sau lăsați câmpul gol.',
    'highlights-1-too-long': 'Primul avantaj este prea lung (max. 22 de caractere).',
    'power-invalid-range': 'Puterea trebuie să fie între 0 și 999.',
    'envkv-consumption-outer-is-empty': 'Introduceți consumul extraurban.',
    'operatinghours-invalid': 'Orele de funcționare indicate sunt invalide.',
    'nominalinterestrate-invalid': 'Rata dobânzii nominale este invalidă.',
    'envkv-combined-power-consumption-invalid': 'Consumul combinat de energie este invalid.',
    'category-invalid': 'Categoria aleasă este invalidă.',
    'price-type-empty': 'Alegeți tipul de preț.',
    'invalid-video-url': 'Link YouTube invalid.',
    'ratepercent-invalid': 'Procentul ratei este invalid.',
    'price-empty': 'Trebuie indicat un preț.',
    'period-invalid': 'Perioada este invalidă.',
    'cubiccapacity-invalid': 'Capacitatea cilindrică indicată este invalidă.',
    'manufacturercolorname-too-long': 'Numele culorii producătorului este prea lung. Maximum 32 de caractere.',
    'deliveryperiod-only-for-new-cars': 'Termenul de livrare poate fi indicat doar pentru vehicule noi.',
    'model-empty': 'Pentru clasa Car modelul este obligatoriu.',
    'fuel-empty': 'Alegeți tipul de combustibil.',
    'modeldescription-contains-phone': 'Descrierea modelului nu poate conține un număr de telefon.',
    'loadingspacelength-invalid': 'Lungimea spațiului de încărcare este invalidă.',
    'model-without-make': 'Alegeți atât marca, cât și modelul.',
    'envkv-and-electricity-failure': 'Pentru combustibil electric trebuie completate mai puține câmpuri EnVKV.',
    'manufacturercolorname-invalid-chars': 'Numele culorii producătorului conține caractere nepermise.',
    'deliverycost-invalid': 'Costul de livrare este invalid.',
    'constructionyear-invalid': 'Anul fabricației indicat este invalid.',
    'usedcarseal-not-permitted': 'Nu aveți dreptul să folosiți sigiliul de mașină rulată ales.',
    'countryversion-missing': 'Versiunea de țară este necesară pentru vehicule noi.',
    'numberofbunks-invalid': 'Numărul de paturi este invalid.',
    'highlights-3-too-long': 'Al treilea avantaj este prea lung (max. 22 de caractere).',
    'highlights-2-too-long': 'Al doilea avantaj este prea lung (max. 22 de caractere).',
    'select-country-version': 'Lipsește versiunea de țară.',
    'highlights-3-invalid-chars': 'Al treilea avantaj conține caractere nepermise.',
    'vehiclelength-invalid': 'Lungimea vehiculului este invalidă.',
    'highlights-1-invalid-chars': 'Primul avantaj conține caractere nepermise.',
    'first-registration': 'Data primei înmatriculări este obligatorie pentru vehiculele rulate.',
    'numberOfPreviousOwners-invalid': 'Numărul proprietarilor anteriori este invalid.',
    'deliverydate-year-too-low': 'Anul livrării este prea mic.',
    'dealer-price-not-supported': 'La anunțurile private nu se poate indica un preț de dealer.',
    'installationheight-invalid': 'Înălțimea de instalare indicată este invalidă.',
    'loadcapacity-invalid': 'Sarcina utilă indicată este invalidă.',
    'usagetype-demonstration-not-for-fsbo': 'Vehiculul demonstrativ nu este permis.',
    'envkv-combined-power-consumption-is-empty': 'Lipsește consumul combinat de energie.',
    'modeldescription-too-long': 'Descrierea modelului este prea lungă (maximum 48 de caractere).',
    'modeldescription-contains-url': 'Descrierea modelului nu poate conține un URL.',
    'vat-rate-not-allowed-for-on-request': 'Cota de TVA nu este permisă la prețul la cerere.',
    'usagetype-unsupported-for-new-vehicles':
      'Un vehicul nou nu poate fi cu înmatriculare anterioară, mașină de angajat de un an, clasic sau demonstrativ.',
    'au-year-too-high': 'Anul inspecției de gaze este invalid. Nu poate fi cu mai mult de 6 ani în viitor.',
    'firstregistration-classiccar-conflict':
      'Pentru un vehicul clasic prima înmatriculare trebuie să fie de cel puțin 20 de ani.',
    'shippingvolume-invalid': 'Volumul de transport este invalid.',
    'currency-invalid-for-site': 'Moneda nu este permisă pentru acest site.',
    'grosscreditamount-invalid': 'Suma brută a creditului este invalidă.',
    'vehiclewidth-invalid': 'Lățimea vehiculului este invalidă.',
    'europalletstoragespaces-invalid': 'Numărul de locuri pentru europaleți este invalid.',
    'constructiondate-invalid': 'Data fabricației este invalidă.',
    'firstregistration-invalid': 'Data primei înmatriculări indicată este invalidă.',
    'manufacturercolorname-contains-url': 'Numele culorii producătorului conține un URL.',
    'condition-classiccar-conflict': 'Un vehicul clasic trebuie să aibă starea „rulat”.',
    'modeldescription-empty': 'Introduceți modelul sau varianta.',
    'category-empty': 'Alegeți o categorie.',
    'usedcarseal-on-damaged-car-warning': 'Sigiliul de mașină rulată nu poate fi atribuit unui vehicul avariat.',
    'loadingspacewidth-invalid': 'Lățimea spațiului de încărcare este invalidă.',
    'envkv-carbon-dioxyd-emission-is-empty': 'Introduceți emisia de CO2.',
    'firstregistration-employeescar-conflict': 'Prima înmatriculare nu poate fi mai veche de 23 de luni.',
    'envkv-consumption-inner-invalid': 'Introduceți un consum urban pozitiv sau lăsați câmpul gol.',
    'delivery-period-xor-delivery-date':
      'Pentru o mașină nouă indicați fie data livrării, fie termenul de livrare, dar nu pe ambele.',
    'envkv energy efficiency class is empty': 'Introduceți clasa de eficiență energetică.',
    'average-price-not-for-damaged-vehicles': 'Prețul mediu nu poate fi calculat pentru vehicule cu daună nereparată.',
    'mileage-used-invalid': 'Kilometrajul introdus este invalid pentru un vehicul rulat.',
    'modeldescription-invalid-chars': 'Descrierea modelului conține caractere nepermise.',
    'deliveryperiod-invalid': 'Termenul de livrare este invalid.',
    'vat-rate-invalid': 'Cota de TVA este invalidă.',
    'price-type-bidding-inconsistent': 'Alegeți tipul de preț.',
    'numberOfPreviousOwners-unsupported': 'Pentru un vehicul nou nu se poate indica numărul proprietarilor anteriori.',
    'damageunrepaired-empty': 'Alegeți dacă vehiculul are o daună nereparată.',
    'internalnumber-invalid-chars': 'Numărul intern conține caractere nepermise.',
    'constructionyear-empty': 'Introduceți anul fabricației.',
    'bank-too-long': 'Numele băncii este prea lung. Maximum 150 de caractere.',
    'firstregistration-newcar-conflict': 'Data primei înmatriculări trebuie să fie goală pentru vehicule noi.',
    'features-contains-invalid-value': 'Dotările conțin o valoare nepermisă.',
    'internalnumber-too-long': 'Numărul intern este prea lung (max. 40 de caractere).',
    'description-too-long': 'Descrierea este prea lungă.',
    'firstregistration-empty': 'Introduceți data primei înmatriculări.',
    'consumerpriceamount-invalid': 'Suma prețului este invalidă. Folosiți doar cifre, fără puncte sau virgule.',
    'liftingcapacity-invalid': 'Capacitatea de ridicare indicată este invalidă.',
    'modeldescription-contains-email': 'Descrierea modelului nu poate conține o adresă de e-mail.',
    'envkv-consumption-inner-is-empty': 'Introduceți consumul urban.',
    'axles-invalid': 'Numărul de axe este invalid.',
    'numseats-invalid': 'Numărul de locuri indicat este invalid.',
    'dealer-price-to-high': 'Prețul de dealer nu poate fi mai mare decât prețul de vânzare.',
    'currency-empty': 'Lipsește moneda.',
    'monthlyrate-invalid': 'Rata este invalidă.',
    'deliverydate-year-too-high': 'Anul livrării este prea mare.',
    'vehicleheight-invalid': 'Înălțimea vehiculului este invalidă.',
    'envkv-consumption-combined-is-empty': 'Introduceți consumul combinat.',
    'netcreditamount-invalid': 'Suma netă a creditului este invalidă.',
    'description-contains-email': 'Descrierea nu poate conține o adresă de e-mail.',
    'description-empty': 'Introduceți o descriere.',
    'duplicate-seller-inventory-key': 'Numărul intern trebuie să fie unic pentru acest vânzător.',
    'ad-only-modifiable-in-dealer-area':
      'Dealerul a blocat modificările acestui anunț. Poate fi schimbat doar în zona dealerului.',
    'licensedweight-invalid': 'Masa maximă autorizată indicată este invalidă.',
    'au-year-too-low': 'Anul inspecției de gaze este invalid. Nu poate fi înainte de anul 1000.',
    'mileage-new-invalid': 'Kilometrajul este invalid pentru un vehicul nou.',
    'hu-year-too-low': 'Anul inspecției tehnice este invalid. Nu poate fi înainte de anul 1000.',
    'internalnumber-contains-email': 'Numărul intern conține o adresă de e-mail.',
    'hu-year-too-high': 'Anul inspecției tehnice este invalid. Nu poate fi cu mai mult de 6 ani în viitor.',
    'renewal-for-site-id-other-than-germany-not-allowed': 'Reînnoirea este permisă doar pentru site-ul Germania.',
    'manufacturercolorname-contains-email': 'Numele culorii producătorului conține o adresă de e-mail.',
    'average-price-only-for-cars': 'Prețul mediu poate fi calculat doar pentru autoturisme.',
    'power-empty': 'Introduceți puterea.',
    'consumer-price-not-in-range': 'Suma prețului este în afara intervalului permis.',
    'make-invalid-category': 'Categoria aleasă nu este permisă pentru marca aleasă.',
    'batterycapacity-invalid': 'Capacitatea bateriei trebuie să fie între 1 și 999 kWh.',
    'modelrange-too-long': 'Gama de modele este prea lungă. Maximum 255 de caractere.',
    'parkassists-cam-360-degrees-and-rear-view-cam-selected':
      'Camera de marșarier și camera 360° nu pot fi alese împreună.',
    'trimline-too-long': 'Linia de echipare este prea lungă. Maximum 255 de caractere.',
    'ad-deleted-by-mobile-quality': 'Anunțul a fost eliminat de echipa de calitate mobile.de.',
    'request-id-too-long': 'Identificatorul cererii este prea lung. Maximum 100 de caractere.',
    'request-id-invalid-characters':
      'Identificatorul cererii conține caractere nepermise. Sunt permise doar caractere alfanumerice.',
    buyer_email_not_allowed: 'Adresa de e-mail a cumpărătorului nu este permisă.',
    invite_for_ad_already_exists: 'Există deja o invitație pentru acest anunț.',
    rating_for_ad_already_exists: 'Există deja o evaluare pentru acest anunț.',
    ad_not_eligible: 'Acest anunț nu poate fi folosit pentru a trimite o invitație.',
    personalized_invite_text_not_supported: 'Textul personalizat al invitației necesită cel puțin pachetul Gold.',
    not_reinviteable: 'Pentru acest anunț nu se poate trimite o nouă invitație.',
    invite_email_invalid: 'Adresa de e-mail a invitației trebuie să fie validă.',
    invite_email_empty: 'Adresa de e-mail a invitației nu poate fi goală.',
    invite_text_empty: 'Textul invitației nu poate fi gol.',
    invite_text_too_long: 'Textul personalizat al invitației poate avea maximum 3000 de caractere.',
    rating_not_supported_for_dealer: 'Gestionarea evaluărilor prin API necesită cel puțin un cont Gold.',
    rating_reply_too_long: 'Un răspuns la evaluare poate avea maximum 1000 de caractere.',
    rating_reply_is_empty: 'Un răspuns la evaluare nu poate fi gol.',
    'charging-time-invalid': 'Timpul de încărcare trebuie să fie între 1 și 1439.',
    'charging-time-fast-invalid': 'Timpul de încărcare rapidă trebuie să fie între 1 și 1439.',
    'content-too-large': 'Fișierul depășește 10 MB permisi.',
    'leasing-only-price-type-cannot-be-changed': 'Tipul de preț al unui anunț doar în leasing nu poate fi schimbat.',
    'leasing-only-ad-cannot-be-activated-without-leasing-rates':
      'Pentru a activa un anunț doar în leasing trebuie setate ratele de leasing.',
    'frame-height-invalid': 'Înălțimea cadrului trebuie să fie între 30 și 80.',
    'frame-number-too-long': 'Numărul cadrului este prea lung. Maximum 25 de caractere.',
    'battery-capacity-wh-invalid': 'Capacitatea bateriei trebuie să fie între 250 și 1500.',
    'weight-e-bike-invalid': 'Greutatea unui e-bike trebuie să fie între 8 și 90.',
    'number-of-gears-invalid': 'Numărul de viteze trebuie să fie între 1 și 24.',
    'condition-of-e-bike-must-be-new': 'Un e-bike trebuie să aibă starea „nou”.',
    'e-bike-cannot-be-changed-to-other-vehicle-class': 'Un e-bike nu poate fi schimbat în altă clasă de vehicul.',
    'classic-leasing-not-allowed-for-e-bike': 'Un e-bike nu poate avea leasing clasic.',
    'trailer-load-braked-invalid': 'Masa remorcii cu frână trebuie să fie între 0 și 99999.',
    'trailer-load-unbraked-invalid': 'Masa remorcii fără frână trebuie să fie între 0 și 99999.',
    'operating-weight-invalid': 'Masa de exploatare trebuie să fie între 0 și 999999.',
    'fuel-tank-volume-invalid': 'Volumul rezervorului trebuie să fie între 0 și 9999.',
    'weight-invalid': 'Masa trebuie să fie între 0 și 999999.',
    'payload-invalid': 'Sarcina utilă trebuie să fie între 0 și 9999.',
    'seatbelt-seats-invalid': 'Numărul de locuri cu centură trebuie să fie între 0 și 9.',
    'individual-contact-duplicate-responsibility': 'Există deja un alt contact individual cu aceeași responsabilitate.',
    'individual-contact-max-count-reached':
      'A fost atins numărul maxim de contacte individuale pentru acest tip de cont.',
    Price_Rating_Repaired_Damage: 'Evaluarea prețului nu poate fi calculată pentru vehicule cu daună reparată.',
    Price_Rating_Vehicle_Is_Damaged: 'Evaluarea prețului nu poate fi calculată pentru vehicule cu daună nereparată.',
    Price_Rating_Not_Roadworthy: 'Evaluarea prețului nu este disponibilă pentru vehicule inapte de circulație.',
    Price_Rating_No_New_Cars: 'Evaluarea prețului nu este disponibilă pentru vehicule noi.',
    Price_Rating_No_Old_Cars: 'Vehiculul este prea vechi pentru o evaluare de preț fiabilă.',
    Price_Rating_Differing_Price_Too_Low: 'Prețul indicat este mult sub intervalul de piață calculat.',
    Price_Rating_Differing_Price_Too_High: 'Prețul indicat este mult peste intervalul de piață calculat.',
    Price_Rating_Only_Cars: 'Evaluarea prețului este disponibilă doar pentru autoturisme.',
    Price_Rating_Not_Possible_Little_Data: 'Nu există suficiente date de piață pentru o evaluare de preț fiabilă.',
    'too-many-photos': 'Au fost alese prea multe fotografii pentru acest cont.'
  }
}

export default mobileDeErrors
